export default __webpack_public_path__ + "static/media/bad-email-verifier.8e9e7954.svg";